import React, {useEffect} from 'react';
import { Form, Row, Col } from 'antd';
import Modal from '@/components/Modal/Modal.jsx';
import Checkbox from '@/components/Form/Checkbox.jsx';

const Pane = ({ map, onOk, ...props }) => {
    const [form] = Form.useForm();

    useEffect(() => {
        form.resetFields();
        form.setFieldsValue({ expUeFlag: true });
    }, [])

    const handleFinish = async ({ expUeFlag }) => {
        onOk({ expUeFlag });
    }

    const handleOk = () => {
        form.submit();
    }

    const cssForm = {
        '.ant-form-item': {
            marginBottom: 0,
        }
    }

    return (
        <Modal title="导出集成用例" width="400px" {...props} onOk={handleOk}>
            <Form form={form} layout="vertical" onFinish={handleFinish} css={cssForm}>
                <Row gutter={[12]}>
                    <Col span={24}>
                        <Form.Item name="expUeFlag">
                            <Checkbox>同时导出界面事件能力描述</Checkbox>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    )
}

export default Pane;